import React from 'react';
import { create } from 'zustand';
import { getPayments } from '../../../api/api';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export const PAYMENT_STATUS = {
  pending: {
    label: 'Ожидает оплаты',
    className: 'text-orange-500',
    icon: <HourglassEmptyIcon fontSize="small" className="text-orange-500" />,
  },
  waiting_for_capture: {
    label: 'Ожидает подтверждения',
    className: 'text-orange-500',
    icon: <HourglassTopIcon fontSize="small" className="text-orange-500" />,
  },
  succeeded: {
    label: 'Успешно',
    className: 'text-green-600',
    icon: <CheckCircleIcon fontSize="small" className="text-green-600" />,
  },
  canceled: {
    label: 'Отменен',
    className: 'text-red-500',
    icon: <CancelIcon fontSize="small" className="text-red-500" />,
  },
};

const STATUS_OPTIONS = Object.entries(PAYMENT_STATUS).map(([value, { label, icon }]) => ({ value, name: label, icon }));

export const usePaymentsStore = create((set) => ({
  data: [],
  total: 0,
  isLoading: false,
  error: null,
  statusOptions: STATUS_OPTIONS,

  fetchPayments: async ({ page, count, searchParams, sort } = {}) => {
    set({ isLoading: true, error: null });

    await getPayments({
      page,
      count,
      searchParams,
      sort,
      dataCb: (res) => {
        set({
          data: res?.items ?? [],
          total: res?.count ?? 0,
          isLoading: false,
        });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },
}));
